import { FunctionComponent, useState } from 'react';
import { Alert, Container, Tab, Tabs, Typography } from '@mui/material';
import { useAuthentication } from '@/hooks/useAuthentication';
import { UserType } from '@/models/user';
import { InsuranceContent } from '@/pageContents/reportsContent/InsuranceContent';

type ReportTab = 'insurance';

export const ReportsPageContent: FunctionComponent = () => {
    const [tab, setTab] = useState<ReportTab>('insurance');
    const { userType } = useAuthentication();

    // The shared permission helpers short-circuit to "allowed" for lift operator
    // sessions (useIsAuthorized, useResolvedSidebarEntries), so the generic guards
    // would let an impersonated operator open this page. The backend answers 403,
    // but the request must not be sent in the first place: these reports compare
    // operators against each other.
    if ((userType as unknown as UserType) === UserType.LiftOperator) {
        return (
            <Container sx={{ pt: 4, pb: 8 }} maxWidth='xl'>
                <Alert severity='warning'>
                    Auswertungen stehen nur der Plattform zur Verfügung.
                </Alert>
            </Container>
        );
    }

    return (
        <Container sx={{ pt: 4, pb: 8 }} maxWidth='xl'>
            <Typography sx={{ mb: 4 }} variant='h4'>
                Auswertungen
            </Typography>

            <Tabs
                value={tab}
                onChange={(_, nextTab: ReportTab) => setTab(nextTab)}
                variant='scrollable'
                scrollButtons='auto'
                sx={{ mb: 3 }}
            >
                <Tab label='Versicherungen' value='insurance' />
            </Tabs>

            {tab === 'insurance' && <InsuranceContent />}
        </Container>
    );
};
